export default class print {
  init() {
    this.loghandler();
  }
  loghandler() {
    window.print();
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/print.js